import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class ToastService {

  constructor(
    private toastrService: ToastrService
  ) {
  }

  info(message: string, title?: string) {
    this.toastrService.info(message, title, { onActivateTick: true, enableHtml: true });
  }

  warning(message: string, title?: string) {
    this.toastrService.warning(message, title, { onActivateTick: true, enableHtml: true });
  }

  success(message: string, title?: string) {
    title = title ? title : "Success!";
    this.toastrService.success(message, title, { onActivateTick: true, enableHtml: true });
  }

  successPersist(message: string): Observable<any> {
    const toast = this.toastrService.success(message, "Success!", { timeOut:300000, extendedTimeOut: 300000, enableHtml: true, closeButton: true });

    return new Observable((o) => {
      toast.onTap.subscribe(() => {
        o.next(toast);
        o.complete();
      })
    })
  }

  error(message: string, title?: string) {
    title = title ? title : "Oops!";
    this.toastrService.error(message, title, { onActivateTick: true, enableHtml: true });
  }

  errorPersist(message: string) {
    this.toastrService.error(message, "Oops!", { timeOut:300000, extendedTimeOut: 300000, enableHtml: true, closeButton: true });
  }
}
